import { render, staticRenderFns } from "./Tanimlar.vue?vue&type=template&id=dd78ba50&"
import script from "./Tanimlar.vue?vue&type=script&lang=js&"
export * from "./Tanimlar.vue?vue&type=script&lang=js&"
import style0 from "./Tanimlar.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports